import AdminHOC from "../../../components/shared/HOC/AdminHOC.jsx";
import { Row, Col } from "antd";
import { useState, useEffect, useRef } from "react";
import { deleteGroup, updateGroup } from "../../../service/GroupService.js";
import ConfirmDeletePopup from "../../../components/shared/confirmDeletePopup/ConfirmDeletePopup.jsx";
import { useNavigate } from "react-router-dom";
import CustomTable from "../../../components/shared/table/Table.jsx";
import CustomTab from "../../../components/shared/tab/TabComponent.jsx";
import CustomButton from "../../../components/global/Button/CustomButton.jsx";
import { getGroupColumns } from "../../../utility/coloumnConstants.js";
import { useGroups } from "../../../hooks/GroupHooks/useGetGroups.js";
import {
  showErrorMessage,
  showSuccessMessage,
} from "../../../components/shared/pagination/messages.js";
import AddGroupModal from "./AddGroupModal.jsx";
import CustomInput from "../../../components/global/CustomInput/CustomInput.jsx";
import LottieIcon from "../../../components/shared/lottieIcon/LottieIcon";
import PageLoader from "../../../components/global/Loader/PageLoader";
import searchIconsvg from "../../../assets/icons/Search-Icon.svg";
import usePagination from "../../../assets/hooks/PaginationHooks/usePagination.jsx";
import CustomModal from "../../../components/global/CustomModal/CustomModal.jsx";

const AllGroup = () => {
  const tableRef = useRef(null);

  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isConfirmPopupOpen, setIsConfirmPopupOpen] = useState(false);
  const [groupToDelete, setGroupToDelete] = useState(null);
  const [visiblePopover, setVisiblePopover] = useState(null);
  const [hoveredButton, setHoveredButton] = useState(null);
  const [activeTab, setActiveTab] = useState("1");
  const [isActive, setIsActive] = useState(true);
  const [modalKey, setModalKey] = useState(0);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [isInputHovered, setIsInputHovered] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [updatedGroupName, setUpdatedGroupName] = useState("");

  const {
    groupList,
    fetchGroups,
  } = useGroups();

  const {
    currentPage,
    pageSize,
    setCurrentPage,
    totalElements,
    setTotalElements,
  } = usePagination();

  const fetchAllGroup = async () => {
    setTableLoading(true);
    try {
      const response = await fetchGroups(currentPage, pageSize, isActive, searchText);
      if (response) {
        setTotalElements(response.totalElements || 0);
      }
    } catch (err) {
      console.error("Fetch Error:", err);
      setTotalElements(0);
    } finally {
      setTableLoading(false);
    }
  };

  const handleEditGroupName = (group) => {
    setSelectedGroup(group);
    setUpdatedGroupName(group.groupName || "");
    setIsEditModalOpen(true);
  };

  const tabList = [
    {
      key: "1",
      label: "Active Groups",
    },
    {
      key: "2",
      label: "Inactive Groups",
    },
  ];

  const handleTableChange = (pagination) => {
    if (pagination) {
      if (pagination.pageSize !== pageSize) {
        setCurrentPage(1);
      } else {
        setCurrentPage(pagination.current);
      }
      const scrollableNode = tableRef.current?.querySelector(".ant-table-body");
      if (scrollableNode) {
        scrollableNode.scrollTo({ top: 0, behavior: "auto" });
      }
    }
  };

  useEffect(() => {
    const debounce = setTimeout(() => {
      const query = searchText?.trim() || "";
      fetchAllGroup(currentPage, pageSize, isActive, query);
    }, 500);
    return () => clearTimeout(debounce);
  }, [currentPage, pageSize, isActive, searchText]);

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleAddNew = () => {
    setModalKey((prev) => prev + 1);
    setIsModalOpen(true);
  };

  const handleOpenConfirmDeletePopup = (group) => {
    setIsConfirmPopupOpen(true);
    setGroupToDelete(group);
  };

  const handleDeleteGroup = async () => {
    try {
      setLoading(true);
      const result = await deleteGroup(groupToDelete?.groupId);

      if (result?.success) {
        showSuccessMessage("Group deleted successfully!");
        fetchAllGroup();
      } else {
        showErrorMessage(
          result?.data || "Error occurred while deleting the Group.",
        );
      }
    } catch (error) {
      showErrorMessage("Something went wrong. Please try again.");
    } finally {
      setIsConfirmPopupOpen(false);
      setGroupToDelete(null);
      setLoading(false);
    }
  };

  const handleUpdateGroupName = async () => {
    try {
      setLoading(true);

      const payload = {
        groupId: selectedGroup?.groupId,
        groupName: updatedGroupName,
      };

      const result = await updateGroup(payload);

      if (result?.success) {
        showSuccessMessage(
          result?.data?.message || "Group name updated successfully!"
        );

        setIsEditModalOpen(false);
        setSelectedGroup(null);
        setUpdatedGroupName("");

        fetchAllGroup();
      } else {
        showErrorMessage(result?.data || "Failed to update group");
      }
    } catch (error) {
      showErrorMessage("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handleViewGroupClick = (id, name) => {
    console.log("usersAdmin name ", id);
    navigate(`/group-history/${id}`, {
      state: { name: name },
    });
  };

  const handleViewGroupReportClick = (id, name) => {
    navigate(`/group-report/${id}`)
  };
  const handleTabChange = (key) => {
    setActiveTab(key);
    setIsActive(key === "1");
    setCurrentPage(1);
    setSearchText("");
  };

  const handleSearch = (value) => {
    setSearchText(value.toLowerCase());
    setCurrentPage(1);
  };

  const fields = getGroupColumns({
    navigate,
    visiblePopover,
    setVisiblePopover,
    hoveredButton,
    setHoveredButton,
    handleViewGroupClick,
    handleOpenConfirmDeletePopup,
    handleViewGroupReportClick,
    handleEditGroupName,
    isActive,
  });

  return (
    <>
      <PageLoader visible={loading} />
      <div className="p-6 flex flex-col border border-[#E8E8E8] rounded-[10px] shadow-[0px_0px_6px_0px_rgba(0,0,0,0.05)] gap-6">
        <div className="flex flex-col gap-6">
          <h1 className="text-[#E74860] text-[1.75rem] font-normal">Groups</h1>
          <div>

            <Row>
              <Col span={7}>
                <CustomTab
                  entries={tabList}
                  activeKey={activeTab}
                  onChange={handleTabChange}
                />
              </Col>

              <Col span={17}>
                <div className="flex gap-[10px] justify-end">
                  <div
                    onMouseEnter={() => setIsInputHovered(true)}
                    onMouseLeave={() => setIsInputHovered(false)}
                  >
                    <CustomInput
                      key={activeTab}
                      className="w-[14vw]"
                      placeholder="Search"
                      value={searchText}
                      onChange={(e) => handleSearch(e.target.value)}
                      icon={
                        isInputHovered
                          ? <LottieIcon name="searchIcon" size={24} shouldPlay={true} />
                          : <img src={searchIconsvg} alt="search" className="w-6 h-6" />
                      }
                      allowClear
                    />
                  </div>
                  <CustomButton
                    onClick={handleAddNew}
                    variant="primary"
                    disabled={!isActive}
                  >
                    Add Group
                  </CustomButton>

                  <CustomButton
                    onClick={() => navigate(`/group-report?status=${isActive ? "active" : "inactive"}`)}
                    variant="primary"
                  >
                    Report
                  </CustomButton>
                </div>
              </Col>
              </Row>

              
                <div ref={tableRef} >
                  <CustomTable
                    data={groupList}
                    scroll={{ y: "48vh"}}
                    columns={fields}
                    showLoader={tableLoading}
                    pagination={{
                      current: currentPage,
                      pageSize: pageSize,
                      total: totalElements,
                      showSizeChanger: true,
                    }}
                    className="hide-scrollbar top-table-radius"
                    onChange={handleTableChange}
                    serverSide={true}
                  />
                </div>
             
          
          </div>
        </div>

        {isModalOpen && (
          <AddGroupModal
            key={modalKey}
            isModalOpen={isModalOpen}
            getGroups={fetchGroups}
            handleCloseModal={handleCloseModal}
            setLoading={setLoading}
          />
        )}
        <ConfirmDeletePopup
          isOpen={isConfirmPopupOpen}
          onClose={() => setIsConfirmPopupOpen(false)}
          onConfirm={handleDeleteGroup}
        />
        <CustomModal
          visible={isEditModalOpen}
          title="Edit Group Name"
          onCancel={() => setIsEditModalOpen(false)}
        >
          <div className="flex flex-col gap-2">
            <CustomInput
              value={updatedGroupName}
              onChange={(e) => setUpdatedGroupName(e.target.value)}
              placeholder="Enter group name"
            />

            <div className="flex gap-2">
              <CustomButton
                className="w-full"
                variant="outlined"
                onClick={() => setIsEditModalOpen(false)}
              >
                Cancel
              </CustomButton>

              <CustomButton
                className="w-full"
                onClick={handleUpdateGroupName}
              >
                Update
              </CustomButton>
            </div>
          </div>
        </CustomModal>

      </div>
    </>
  );
};

export default AdminHOC(AllGroup);